<template>
  <div class="all" :class="{ isFixed: isFixed }">
    <div class="typeNav">
      <div class="container clearfix">
        <div
          class="type fl"
          @mouseover.stop="enterType"
          @mouseleave="leaveType"
        >
          <div class="clearfix">
            <p class="fl menu">
              <img
                class="menuImg"
                src="../../assets/icon/header/meun.png"
                alt=""
              />
            </p>
            <span class="txt fl">{{ $t("typeNav.fenlei") }}</span>
            <p class="fr arrow">
              <img v-if="!showFirst" class="arrowTopImg" alt="" />
              <img v-if="showFirst" class="arrowBottomImg" alt="" />
            </p>
          </div>
          <div class="menuList">
            <menuList  :list="cataList" :SeasonalZoneList="SeasonalZoneList" ></menuList>
          </div>
          
        </div>
        <!-- 专区名称 -->
        <div class="theZone fl">
          <div class="zoneItemGroup" ref="zoneItemGroup">
            <div
              class="zoneItem"
              @click="common.linkList(item)"
              v-for="(item, index) in advertiseSpace"
              :key="index"
              :class="[SeleFunction(item),lang==1 && item.TypeId != 'promwebfunction' ? 'p13' : '',item.TypeId == 'promwebfunction' ? 'vip' : '']"   
              :style="{
                marginRight:
                  index == advertiseSpace.length - 1 ? '0px' : zoneItemMR + 'px'
              }"
            >
              <img v-if="item.TypeId == 'promwebfunction' " :src="item.fileName" style="width: 114px;" alt="">
              <div v-else>
                {{ item.AdName }}
              </div>
            </div>
            <!-- <img class="hot_img" src="../../assets/icon/hot_icon.gif" alt="" /> -->
            <img class="hot_img lp" src="../../assets/icon/hot_icon.gif" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuList from "./menuList.vue";
export default {
  name: "typeNav",
  props: {
    isIndex: false,
    noJump: false
  },
  components: {
    menuList
  },
  data() {
    return {
      lang: 1,
      advertiseSpace: [],
      decGoods: [],
      cataList: [],
      secondList: [],
      recoImg: "",
      showFirst: false,
      showSecond: false,
      showAdvert: false,
      oneIndex: null,
      twoIndex: null,
      threeIndex: null,
      isFixed: false,
      offsetTop: 0,
      cateClickFlag: false,
      indexStatus: false,
      zoneItemMR: 0,
      isMobile: false,
      WebFunctionID: null,
      innerTypeList: false,
      ProductCataID:null,
      TypeId:null,
      SeasonalZoneList:[],
      // navpic:{}
    };
  },
  watch: {
    isIndex: {
      immediate: true,
      handler(newValue, oldValue) {
        //父组件param对象改变会触发此函数
        this.indexStatus = newValue;
      },
      deep: true
    },
    "$route":function(to,from){
      this.ProductCataID = to.query.ProductCataID ? to.query.ProductCataID : '';
      // console.log(to.query);
      this.WebFunctionID = to.query.query ? to.query.query.WebFunctionID : '';
    }
  },
  created() {
    this.lang = localStorage.getItem("lang");
  },
  mounted() {
    // 首页分类首屏默认展开  其他页面默认不展开
    if (this.indexStatus) {
      this.showFirst = true;
    } else {
      this.showFirst = false;
    }
    window.addEventListener("scroll", this.initHeight);
    this.$nextTick(() => {
      this.offsetTop = document.querySelector(".all").offsetTop;
    });
    this.GetCatasPC();

    if (localStorage.getItem("lang") && localStorage.getItem("cityInfo")) {
      this.getData();
    }
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ) ||
      document.body.clientWidth < 1050
    ) {
      this.isMobile = true;
    }
    
    this.ProductCataID = this.$route.query.ProductCataID;
    this.WebFunctionID = this.$route.query.WebFunctionID;
    // console.log(this.$route.query.WebFunctionID,this.$route.query.ProductCataID);
    this.TypeId = this.$route.query.TypeId
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    initHeight() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop + 120 ? true : false;
      // if(this.isFixed){
      //     this.showFirst = false;
      //     this.showSecond = false;
      //     this.showAdvert = false;
      // }else if(!this.isFixed && this.indexStatus){
      //     this.showFirst = true;
      // }
    },
    SeleFunction(item){
      let text;
      // console.log(this.WebFunctionID,item.WebFunctionID,this.ProductCataID,item.ProductCataId);
      if(Number(this.WebFunctionID) == Number(item.WebFunctionID)){
        if(Number(this.ProductCataID) ==Number(item.ProductCataId)){
             text= 'blueBg';
        }else if(this.WebFunctionID == 100001){
          text= 'blueBg';
        }else{
          text=''
        }
      }
      return text;
    },
    hideCate() {
      this.showFirst = !this.showFirst;
    },
    enterType() {
      this.showFirst = true;
      $(".menuList").show();
    },
    leaveType() {
      this.showFirst = false;
      $(".menuList").hide();
    },
    enterFirst(val) {
      this.timer2 && clearTimeout(this.timer2);
      this.showFirst = val;
      this.showSecond = val;
      this.showAdvert = false;
    },
    mEnterList() {
      this.innerTypeList = true;
    },
    showSec(item, index, val) {
      this.secondList = item.childList;
      this.oneIndex = index;
      this.showSecond = val;
      this.enterFirst(true)
    },
    enterSec(item, index, val) {
      this.twoIndex = index;
      this.recoImg = item.CataImg;
      this.decGoods = item.recomlist;
      this.showAdvert = true;
    },
    handleScroll() {
      //console.log(this.divInter('typeBox'))
      let _this = this;
      // console.log(this.innerTypeList);
      if (!this.innerTypeList) {
        this.timer2 = setTimeout(() => {
          _this.showFirst = false;
          _this.showSecond = false;
          _this.showAdvert = false;
          _this.oneIndex = null;
          _this.twoIndex = null;
          _this.threeIndex = null;
        }, 500);
      }
    },
    // 获取所有分类
    GetCatasPC() {
      const _this = this;
      this.$store
        .dispatch("GetCatasPC", {
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : ""
        })
        .then(({ Data }) => {
          // console.log("获取到的数据",Data);
          _this.cataList = Data.catas;
          // _this.navpic = Data.navpic ? Data.navpic : {};
          // Data.catas[0].childList.forEach(item=>{
          //   _this.cataList[0].childList.push(item)
          // })
          if(Data.SeasonalZoneList && Data.SeasonalZoneList.length > 0){
            _this.SeasonalZoneList = Data.SeasonalZoneList;
          }
        });
    },
    // 获取右侧广告位
    getData() {
      this.$store
        .dispatch("GetPCHome", {
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : ""
        })
        .then(({ Data }) => {
          let that = this;
          that.$emit("getData", Data);
          this.zoneItemMR = 0;
          this.advertiseSpace = Data.CataRightPlace;
          // console.log(this.advertiseSpace);
          this.advertiseSpace=this.advertiseSpace.map(item=>{
            if(item.TypeId=="sales"){
            item.WebFunctionID = 100001;
            }
            return item
          })
          // console.log(this.advertiseSpace);
          setTimeout(function() {
            let width = that.$refs.zoneItemGroup.offsetWidth;
            // console.log(width)
            that.zoneItemMR = parseInt((823 - width) / 7, 10);
            // console.log(that.zoneItemMR)
          }, 200);
        });
    },
    
    filterChildList(childList) {
      let result = [];
      if (Array.isArray(childList) && childList.length > 0) {
        for (var i = 0; i < childList.length; i += 3) {
          result.push(childList.slice(i, i + 3));
        }
      }
      return result.length > 0 ? result : childList;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    this.timer && clearTimeout(this.timer);
  }
};

$(function() {
  $("body").on("mouseleave", ".typeList", function() {
    $(this).hide();
  });
});
</script>
<style lang="scss" scoped>
@import "../../style/base.scss";
@import "../../style/color.scss";
.all {
  // width: 100%;
  height: 35px;
  max-width: 1903px;
  margin: 0 auto;
  // background: #f0f3f8 !important;

  // background-image: url("https://mktcdn.epermarket.com/Resource/public/guide/bot2.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.all.isFixed {
  position: fixed;
  top: 40px;
  // width: 1903px;
  // left: 951px;
  // transform: translateX(-50%);
  // top: 0px;
  left: 0px;
  right: 0px;

  margin-left: auto;
  margin-right: auto;
  // left: 0px;
  z-index: 1999;
}
.blueBg {
  color: #fff;
  background-color: $c_159 !important;
}

.typeNav {
  background: #fff;
  width: 1050px;
  margin: 0 auto;
  .container {
    position: relative;
    width: 100%;
    height: 35px;
    .type {
      width: 247px;
      height: 35px;
      background: $c_000;
      padding: 0 19px 0 25px;
      box-sizing: border-box;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      .menuList{
        display: none;
      }
      .clearfix {
        display: block;
      }
      .txt {
        margin-left: 35px;
        margin-right: 30px;
        display: inline-block;
        width: 90px;
        height: 35px;
        line-height: 35px;
        font-weight: bold;
        flex: 1;
        text-align: center;
      }
      .menu {
        padding-top: 8px;
        box-sizing: border-box;
        width: 24px;
        flex: 0 0 24px;
        .menuImg {
          width: 24px;
          height: 19px;
        }
      }
      .arrow {
        width: 12px;
        margin-top: 8px;
        box-sizing: border-box;
        margin-right: 10px;
        flex: 0 0 12px;
        .arrowBottomImg {
          width: 17px;
          height: 17px;
          @include arrowAfterBottom(#ffffff);
        }
        .arrowTopImg {
          width: 17px;
          height: 17px;
          margin-top: 8px;
          @include arrowAfterTop(#ffffff);
        }
      }
    }
    .typeList {
      width: auto;
      opacity: 1;
      position: absolute;
      left: 0;
      top: 35px;
      z-index: 299;
      cursor: pointer;
      box-shadow: 1px 2px 3px #00000029;
      .line {
        width: 100%;
        height: 3px;
        background: $c_6DB;
      }
      .left {
        z-index: 99;
        //box-shadow: 2px 0px 20px #000000;
      }
      .middle {
        //box-shadow: 2px 0px 20px #000000;
      }
      .right {
        //box-shadow: 2px 0px 20px #000000;
      }
      .LevelOne {
        width: 247px;
        height: 397px;

        padding-bottom: 15px;
        box-sizing: border-box;
        // background: #FEFEFE;
        background: rgba(255, 255, 255, 0.95);
        font-family: "EperFontBold";
        .main {
          width: 100%;
          height: 100%;
          padding: 22px 27px 0px;
          box-sizing: border-box;
          &.hasline {
            padding-top: 22px;
            border-right: 1px solid #ccc;
          }
          .oneItem {
            font-size: 12px;
            color: #000;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .oneItem.seasonal{
            color: #fe6b00;
            position: relative;
            // .fireicon{
            //   width: 15px;
            //   height: 15px;
            // }
          }
          // .oneItem.seasonal:hover{
          //   color: $c_6DB;
          // }
          .oneItem.active {
            color: $c_6DB;
          }
          .oneItem:last-child {
            margin-bottom: 0;
          }
        }
      }
      .otherLevel {
        width: 381px;
        height: 397px;
        padding: 23px 0 20px 20px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.95);
        font-family: "EperFontLight";
        .main {
          width: 100%;
          height: 100%;
          border-right: 1px solid #ccc;
          padding-right: 28px;
          box-sizing: border-box;
          overflow: auto;
          .second_class {
            font-size: 12px;
            font-weight: bold;
            color: $c_000;
            margin-bottom: 5px;
            .leftLine {
              display: inline-block;
              width: 4px;
              height: 10px;
              background: $c_716;
              margin-right: 14px;
            }
            .leftLine.active {
              background: $c_6DB;
            }
            .name.active {
              color: $c_6DB;
            }
          }
          .third_class {
            font-size: 12px;
            padding-left: 24px;
            box-sizing: border-box;
            margin-bottom: 5px;
            .name {
              // word-break:break-all;
              word-break: keep-all;
              word-wrap: break-word;
              display: inline-block;
              padding-right: 5px;
              font-family: EperFontLight;
              span {
                font-family: EperFontLight;
                color: $c_000;
              }
              span:hover {
                color: $c_6DB;
              }
              &:hover {
                color: $c_6DB;
              }
            }
          }
        }
      }
      .advert_space {
        width: 422px;
        height: 397px;
        padding: 23px 43px 14px 46px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.95);
        .text {
          margin-bottom: 12px;
          text-align: center;
          font-size: 12px;
          color: $c_6DB;
        }
        .rec_goods {
          height: 210px;
          .item {
            width: 150px;
            .img {
              width: 150px;
              height: 150px;
              margin-bottom: 10px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .name {
              font-size: 12px;
              @include ellipsisMore(2);
              font-family: "EperFontLight";
              &:hover {
                text-decoration: underline;
              }
            }
            .label {
              font-size: 14px;
              color: $c_ec1;
            }
          }
          .item:first-child {
            margin-right: 20px;
          }
        }
        .rec_img {
          width: 100%;
          height: 112px;
          border: 2px solid $c_999;
          padding: 5px;
          box-sizing: border-box;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .theZone {
      padding-left: 15px;
      width: 803px;
      height: 35px;
      border-top: 1px solid $c_f7f;
      border-right: 1px solid $c_f7f;
      border-bottom: 1px solid $c_f7f;
      box-sizing: border-box;
      font-size: 14px;
      color: $c_000;
      .zoneItemGroup {
        display: flex;
        position: relative;
        margin: 4px 0;
        justify-content: space-between;
        .hot_img {
          position: absolute;
          left: -20px;
          top: -18px;
          width: 80px;
          z-index: 100;
        }
        .lp{
          left: 105px;
        }
      }
      .zoneItem.vip{
        cursor: pointer;
        // padding: 0 5px;
        height: 25px;
        border: none;
        &.p13{
           padding: 0 13px;
        }
        &:hover {
          // color: $c_6DB !important;
          background: none;
        }
      }
      .zoneItem.vip.blueBg{
        background: none !important;
      }
      .zoneItem {
        font-size: 12px;
        font-family: EperFontBold;
        cursor: pointer;
        text-align: center;
        white-space: nowrap;
        border: 1px solid $c_159;
        border-radius: 30px;
        padding: 0 5px;
        height: 25px;
        line-height: 25px;
        flex-shrink:0;
        background: #fff;
        &.p13{
           padding: 0 13px;
        }
        &:hover {
          // color: $c_6DB !important;
          background-color: $c_159;
          color:#fff ;
        }
      }
      .zoneItem:last-child {
        margin-right: 0px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/typeNav.vue